import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles/ScenarioCardInfo.module.css";
import { FaEye, FaHeart, FaRegHeart, FaTags, FaShareSquare } from "react-icons/fa";

const ScenarioCardInfo = ({
    scenario,
    userId,
    likesCount,
    hasBeenLiked,
    isHovered,
    handleClickLikeScenario,
    setShowShareModal,
    onShowTags,
    setHovered,
}) => {
    const navigate = useNavigate();

    const handleTitleClick = () => {
        if (scenario.isPublished) {
            navigate(`/view/${scenario._id}`);
        }
    };

    const handleShareClick = (e) => {
        if (scenario.isPublished) {
            e.stopPropagation();
            e.preventDefault();
            setShowShareModal(true);
        }
    };

    const handleLikeClick = () => {
        if (scenario.isPublished) {
            handleClickLikeScenario();
        }
    };

    const handleAuthorClick = (e) => {
        e.preventDefault();
        navigate(`/user/${scenario.creator?.username}`);
    };

    return (
        <div className={styles.infoBody}>
            <div className={styles.titleContainer}>
                <div
                    id={`scenario-title-${scenario._id}`}
                    className={`${styles.title} ${isHovered ? styles.hovered : ""}`}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    title={scenario.title}
                    onClick={handleTitleClick}
                    style={{ cursor: scenario.isPublished ? "pointer" : "default" }}
                >
                    {scenario.title || "Untitled"}
                </div>
            </div>
    
            {/* --- Author --- */}
            <div className={styles.userDateContainer}>
                <a
                    href={`/user/${scenario.creator?.username}`}
                    onClick={handleAuthorClick}
                    className={styles.usernameLink}
                >
                    {scenario.creator?.username || "Unknown Author"}
                </a>
            </div>

            {scenario.isPrivate && (
                <div className={styles.membersOnlyIndicator}>
                    <svg className={styles.membersOnlyIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                    </svg>
                    <span className={styles.membersOnlyText}>Members Only</span>
                </div>
            )}
    
            {/* --- Stats Bar (Likes, Views, Share, Tags) --- */}
            <div className={styles.statsContainer}>
                <div className={styles.leftStatsGroup}>
                    <div className={styles.statItem} title="Likes">
                        <button
                            className={`${styles.iconButton} ${styles.likeButton}`}
                            onClick={handleLikeClick}
                            disabled={!userId || !scenario.isPublished}
                            aria-pressed={hasBeenLiked}
                            aria-label={hasBeenLiked ? "Unlike Scenario" : "Like Scenario"}
                        >
                            {userId ? (
                                hasBeenLiked ? (
                                    <FaHeart className={styles.likeIconFilled} />
                                ) : (
                                    <FaRegHeart className={styles.likeIconOutline} />
                                )
                            ) : (
                                <FaRegHeart className={styles.likeIconOutline} />
                            )}
                        </button>
                        <span className={styles.statCount}>{likesCount ?? 0}</span>
                    </div>
    
                    <div className={styles.statItem} title="Views">
                        <FaEye className={styles.viewsIcon} />
                        <span className={styles.statCount}>{scenario.views ?? 0}</span>
                    </div>
                </div>
    
                <div className={styles.rightStatsGroup}>
                    <div className={styles.statItem} title="Share">
                        <button
                            className={`${styles.iconButton} ${styles.shareIconButton}`}
                            onClick={handleShareClick}
                            disabled={!scenario.isPublished}
                            aria-label="Share Scenario"
                        >
                            <FaShareSquare className={styles.shareIcon} />
                        </button>
                    </div>
    
                    {scenario.tags && scenario.tags.length > 0 && (
                        <button
                            className={`${styles.iconButton} ${styles.tagsButton}`}
                            onClick={onShowTags}
                            title="View Tags"
                            aria-label="View Tags"
                        >
                            <FaTags className={styles.tagsIcon} />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
    
};

export default ScenarioCardInfo;